module.exports = "//static.hsappstatic.net/growthhub-ui/static-1.588/img/growthhub.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./img/growthhub.svg
// module id = 267
// module chunks = 0